import { create } from "zustand";

const useCanvasRulersTool = create((set, get) => ({
  shown: false,
  setShown: (shown) => {
    set({ shown });
  }
}))

export default useCanvasRulersTool;